import _ from 'lodash';
import api from '../../api';


const state = {
	// instance: null,
	// B
	// fetching: false,
	// fetched: false,
	// R
	// instance_loading: false,
	// instance_loaded: false,
	// E-A
	instance_saving: false,
	instance_saved: false,
	// D
	instance_deleting: false,
	instance_deleted: false,
};


const actions = {


	upload: function (context, {file, index}) 
	{
		const promise = api.media.store({file: file}, index);
		context.commit('handleStatus', { instance_saving: true });
		return promise
			.then((response) => {
				context.commit('handleStatus', { instance_saved: true });
				context.commit('handleInstanceSaved', response.data);
			})
			.catch((error) => {
				context.commit('handleStatus', { instance_saved: false	});
				context.commit('handleInstanceFailed', error);
			})
			.then(() => {
				context.commit('handleStatus', { instance_saving: false });
			}); 
	},

	delete: function (context, uuid) 
	{
		const promise = api.media.delete(uuid);
		context.commit('handleStatus', { instance_deleting: true });
		return promise
			.then((response) => {
				context.commit('handleStatus', { instance_deleted: true });
				context.commit('handleInstanceDeleted', uuid);
			})
			.catch((error) => {
				context.commit('handleStatus', { instance_deleted: false });
				context.commit('handleInstanceFailed', error);
			})
			.then(() => {
				context.commit('handleStatus', { instance_deleting: false });
			}); 
	},

}



const mutations = {

	handleInstanceSaved: function (state, payload)
	{
		state = Object.assign({}, state);
		// just for event subscribing...
	},

	handleInstanceDeleted: function (state, payload)
	{
		state = Object.assign({}, state);
		// just for event subscribing...
	},

	handleInstanceFailed: function (state, payload)
	{
		state = Object.assign({}, state);
		// just for event subscribing...
	},	

	handleStatus: function (state, payload) 
	{
		_.each(payload, (value, key) => _.set(state, key, value));
	},
};


const getters = {

}



export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}			